import ViewUI from 'view-design'

export default {
    clone: function (D) {
        var E = JSON.stringify(D);
        return E = eval("(" + E + ")")
    },
    //获取当前年月日
    timestampToTime: function (timestamp) {
        var date;
        if (timestamp) {
            date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        } else {
            date = new Date(); //获取当前时间
        }

        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    //移动光标到行尾
    moveEnd: function (obj) {
        obj.focus();
        var len = obj.value.length;
        if (document.selection) {
            var sel = obj.createTextRange();
            sel.moveStart('character', len); //设置开头的位置
            sel.collapse();
            sel.select();
        } else if (typeof obj.selectionStart == 'number' && typeof obj.selectionEnd == 'number') {
            obj.selectionStart = obj.selectionEnd = len;
        }
    },
    message: function (msg, type) {
        var dsq = setInterval(function () {
            // eslint-disable-next-line no-undef
            if (uApp) {
                clearInterval(dsq);
                ViewUI.Message[type](msg);
            }
        }, 200)
    },
    // 按回车后跳到下一个输入框
    nextInput: function (e) {
        // eslint-disable-next-line no-undef
        var inputs = $("input");
        for (var i = 0; i < inputs.length; i++) {
            // 如果是最后一个，则焦点回到第一个   
            if (i == (inputs.length - 1)) {
                inputs[0].focus();
                break;
            } else if (e.target == inputs[i]) {
                inputs[i + 1].focus();
                break;
            }
        }
    },
    //获取当前年月日 格式YYYY-MM-DD
    formatDate: function (timestamp) {
        var date = null;
        if (timestamp) {
            date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        } else {
            date = new Date(); //获取当前时间
        }
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    Stopwatch: {
        oStart: function () {
            console.log(1111)
        }
    },
    returnFormattedToMilliseconds: function (time) {
        // var milliseconds = Math.floor((time % 1000) / 100),
        // hours = Math.floor((time/(1000*60*60)) % 24);
        var seconds = Math.floor((time / 1000) % 60),
            minutes = Math.floor((time / (1000 * 60)) % 60),
            hours = Math.floor(time / (1000 * 60 * 60));
        seconds = seconds < 10 ? '0' + seconds : seconds;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        hours = hours ? hours + ":" : '';
        return hours + minutes + ":" + seconds;
    },
    isError(req, hide) { //请求出错处理 req:ajax返回的数据，hide:是否隐藏错误提示
        if (!req) return true;
        if (req.success) {
            return false;
        }
        if (req.error) {
            if (!hide)
                ViewUI.Message.error(req.error.messages || '数据请求出错了!');
            return true;
        }
        if (req.meta.code != 200) {
            if (!hide) {
                if (req.meta.msg)
                    ViewUI.Message.error(req.meta.msg);
                else
                    ViewUI.Message.error('“服务器出现了一点小状况，请您耐心等一下……”');
            }
            return true;
        }
        return false;
    },

    /**
     * Parse the time to string
     * @param {(Object|string|number)} time
     * @param {string} cFormat
     * @returns {string}
     */
    parseTime(time, cFormat) {
        if (arguments.length === 0) {
            return null
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
            date = time
        } else {
            if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                time = parseInt(time)
            }
            if ((typeof time === 'number') && (time.toString().length === 10)) {
                time = time * 1000
            }
            date = new Date(time)
        }
        const formatObj = {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            h: date.getHours(),
            i: date.getMinutes(),
            s: date.getSeconds(),
            a: date.getDay()
        }
        const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
            let value = formatObj[key]
            // Note: getDay() returns 0 on Sunday
            if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
            if (result.length > 0 && value < 10) {
                value = '0' + value
            }
            return value || 0
        })
        return time_str
    },

    log(obj) {
        var str = '时间:' + new Date().toLocaleString() +
            '\nsocket:' + obj.name +
            '\n数据:' + JSON.stringify(obj.data);
        // 发送错误日志
        localStorage.setItem('log', localStorage.getItem('log') + str);
    },

    navigation(url, parame) {
        let par = [];
        if (parame) {
            for (const key in parame) {
                if (Object.hasOwnProperty.call(parame, key)) {
                    const element = parame[key];
                    par.push(key + '=' + element)

                }
            }
        }
        window.location.href = url + par.join('&');
    },
    back() {
        window.history.back();
    },
    // 症状列表按患者信息过滤
    diagnosticListFilter(list, age, sex) {
        return list.filter(i => {
            if (this.validata(i, age, sex)) {
                i.symptomSubTypeList = i.symptomSubTypeList.filter(j => {
                    if (this.validata(j, age, sex)) {
                        j.symptomList = j.symptomList.filter(k => {
                            if (this.validata(k, age, sex)) {
                                return true;
                            }
                        });
                        return true;
                    }
                });
                return true;
            }
        });
    },
    // 症状列表按患者信息过滤-处理函数
    validata(item, age, sex) {
        if (item.ageE == 0) item.ageE = 150;
        if (item.sex == 0 || item.sex == sex) {
            if (item.ageS <= age && item.ageE > age) {
                return true;
            }
        }
        return false;
    },
    formatNumber(nb, unit) {
        let n_nb = (nb / 10000).toFixed(2) * 1;
        if (unit) n_nb += '万'
        return nb > 10000 ? n_nb : nb;
    },
    formatNumber2(nb) {
        let n_nb = (nb / 1000).toFixed(2) * 1;
        return n_nb;
    },
    isDark() {
        let h = new Date().getHours()
        return !(h > 7 && h < 18);
    },
    // 高亮关键词
    highlightKeyword(str, keyword) {
        return str ? str.replaceAll(keyword, "<span class='red'>" + keyword + "</span>") : ""
    },
    // 批量高亮关键词
    batchHighlightKeyword(str, keyword) {
        let keywordList = keyword.split(/\s+/);
        keywordList.forEach(k => {
            str = this.highlightKeyword(str, k);
        })
        return str;
    },

    // 目录数据格式化
    catalogueFormatData(list, index) {
        let level = 'level' + index;
        let item = list.find(i => i[level] == 0);
        if (item) {
            let l1 = list.filter(i => i[level] != 0);
            let ids = [];
            l1.forEach(i => {
                if (!ids.includes(i[level])) {
                    ids.push(i[level])
                }
            });
            item.children = ids.map(i => {
                let l2 = l1.filter(j => j[level] == i);
                if (l2.length) {
                    return this.catalogueFormatData(l2, index + 1)
                }
            })
        }
        return item;
    },
    // 目录数据处理
    catalogueToList(list, parent) {
        let arr = [];
        list.forEach(i => {
            if (i) {
                arr.push({
                    id: i.id,
                    bookId: i.bookId,
                    biaoTi: i.biaoTi,
                    parent
                })
                if (i && i.children && i.children.length) {
                    arr.push(...this.catalogueToList(i.children, i.id))
                }
            }
        })
        return arr;
    },
    /** 
     * 下载文件 
     * @param {*} blob 
     * @param {*} filename 
     */
    downloadFile(url) {
        const a = document.createElement("a");
        document.body.append(a);
        a.download = url;
        a.target = '_blank';
        a.href = url;
        a.click();
    },

    // 解析URL的get参数
    parseUrlParams(url) {
        const params = {};
        const urlParams = new URLSearchParams(url);
        for (const [key, value] of urlParams) {
            params[key] = value;
        }
        return params;
    },

    // 手机号验证方法
    isPhone(phone) {
        return /^1[3456789]\d{9}$/.test(phone);
    }

}